import {BaseTrackingEvent} from '@udemy-v2/event-tracking';

export interface SubscriptionPlanPricingOption {
    price: string;
    listPrice: string;
    currency: string;
    renewalIntervalType: 'month' | 'day' | 'year' | 'week';
    renewalIntervalCount: number;
    hasTrial: boolean;
    trialDays?: number | null;
}

export class SubscriptionPlanPricingOptionEvent {
    price: string;
    listPrice: string;
    currency: string;
    renewalIntervalType: 'month' | 'day' | 'year' | 'week';
    renewalIntervalCount: number;
    hasTrial: boolean;
    trialDays?: number | null;

    constructor({
        price,
        listPrice,
        currency,
        renewalIntervalType,
        renewalIntervalCount,
        hasTrial,
        trialDays,
    }: {
        price: string;
        listPrice: string;
        currency: string;
        renewalIntervalType: 'month' | 'day' | 'year' | 'week';
        renewalIntervalCount: number;
        hasTrial: boolean;
        trialDays?: number | null;
    }) {
        this.price = price;
        this.listPrice = listPrice;
        this.currency = currency;
        this.renewalIntervalType = renewalIntervalType;
        this.renewalIntervalCount = renewalIntervalCount;
        this.hasTrial = hasTrial;
        this.trialDays = trialDays;
    }
}

export class SubscriptionOfferPresented implements BaseTrackingEvent {
    readonly _type = 'SubscriptionOfferPresented';
    primaryPricingOption: SubscriptionPlanPricingOption;
    allPricingOptions: SubscriptionPlanPricingOption[];
    productType: 'consumer' | 'team';
    countryCode: string;
    courseId: number | null;
    courseTrackingId: string | null;
    badges: string[] | null;
    uiRegion: string;

    constructor({
        uiRegion,
        primaryPricingOption,
        countryCode,
        pageFor,
    }: {
        uiRegion: string;
        primaryPricingOption: SubscriptionPlanPricingOption;
        countryCode: string;
        pageFor: string | null;
    }) {
        this.primaryPricingOption = primaryPricingOption;
        this.allPricingOptions = [primaryPricingOption];
        this.productType = 'consumer';
        this.countryCode = countryCode;
        this.courseId = null;
        this.courseTrackingId = null;
        this.badges = null;

        if (pageFor) {
            this.uiRegion = uiRegion + '_' + pageFor;
        } else {
            this.uiRegion = uiRegion;
        }
    }
}

export class SubscriptionLearnMoreEvent implements BaseTrackingEvent {
    readonly _type = 'SubscriptionLearnMoreEvent';
    planPriceId: string;
    planPriceIds: number[] | null;
    planType: string;
    noticeId: number | null;
    url: string | null;
    uiRegion: string;

    constructor({
        planPriceId,
        planType = 'CONSUMERSUBSCRIPTION',
        uiRegion,
        planPriceIds,
        pageFor,
    }: {
        planPriceId: string;
        planType?: string;
        uiRegion: string;
        planPriceIds?: number[] | null;
        pageFor?: string | null;
    }) {
        this.planPriceId = planPriceId;

        if (planPriceIds !== undefined) {
            this.planPriceIds = planPriceIds;
        } else {
            const parsedPlanPriceId = Number(planPriceId);
            if (!isNaN(parsedPlanPriceId) && parsedPlanPriceId > 0) {
                this.planPriceIds = [parsedPlanPriceId];
            } else {
                this.planPriceIds = null;
            }
        }

        this.planType = planType;
        this.noticeId = null;
        this.url = null;

        if (pageFor) {
            this.uiRegion = uiRegion + '_' + pageFor;
        } else {
            this.uiRegion = uiRegion;
        }
    }
}

export class LandingPageCTASelected implements BaseTrackingEvent {
    readonly _type = 'LandingPageCTASelected';
    componentName: string;
    landingPage = '60dayhustle';

    constructor({componentName, pageFor}: {componentName: string; pageFor: string | null}) {
        if (pageFor) {
            this.componentName = componentName + '_' + pageFor;
        } else {
            this.componentName = componentName;
        }
    }
}

export class DiscoveryItemClickEvent implements BaseTrackingEvent {
    readonly _type = 'DiscoveryItemClickEvent';
    type: string;
    id: number;
    trackingId: string;
    backendSource: string;
    position: number;
    uiRegion: string;
    serveTrackingId: string;

    constructor({
        type,
        id,
        trackingId,
        backendSource,
        position,
        uiRegion,
        pageFor,
    }: {
        type: string;
        id: number;
        trackingId: string;
        backendSource: string;
        position: number;
        uiRegion: string;
        pageFor?: string | null;
    }) {
        this.type = type;
        this.id = id;
        this.trackingId = trackingId;
        this.backendSource = backendSource;
        this.position = position;
        this.serveTrackingId = '';

        if (pageFor) {
            this.uiRegion = uiRegion + '_' + pageFor;
        } else {
            this.uiRegion = uiRegion;
        }
    }
}
